import { render, staticRenderFns } from "./LabelTable.vue?vue&type=template&id=3024a5b9"
import script from "./LabelTable.vue?vue&type=script&lang=js"
export * from "./LabelTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports